module.exports = __webpack_public_path__ + "img/img-4.cf63377a.png";